import React from 'react';
import { Network, Search, Shield, Bell, Eye } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

export const SubdomainsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Subdomain Discovery & Management"
      description="Discover, monitor, and manage all your subdomains to enhance your security posture and reduce your attack surface."
      icon={<Network className="h-8 w-8 text-blue-600" />}
      featureName="subdomains"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Automated Discovery</h3>
          </div>
          <p className="text-gray-400">
            Automatically discover and inventory all subdomains across your organization with advanced scanning techniques.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Vulnerability Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify security vulnerabilities and misconfigurations in your subdomains with comprehensive security scanning.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Bell className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Continuous Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor subdomain changes and detect shadow IT infrastructure with real-time alerting and notifications.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Eye className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Attack Surface Visibility</h3>
          </div>
          <p className="text-gray-400">
            Gain complete visibility into your subdomain attack surface to identify and mitigate potential security risks.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};


